import { useEffect } from 'react';

export default function useMoengageEvents() {
  useEffect(() => {
    function handler(event) {
      if (
        event.detail.name === 'MOE_ONSITE_MESSAGE_SHOWN' &&
        event.detail.data &&
        event.detail.data.length
      ) {
        //do some processing on event.detail.data
      }

      if (
        event.detail.name === 'MOE_ONSITE_MESSAGE_CLICKED' &&
        event.detail.data &&
        event.detail.data.length
      ) {
        //do some processing on event.detail.data
      }

      if (
        event.detail.name === 'MOE_ONSITE_MESSAGE_DISMISSED' &&
        event.detail.data &&
        event.detail.data.length
      ) {
        //do some processing on event.detail.data
      }

      if (
        event.detail.name === 'MOE_ONSITE_MESSAGE_AUTO_DISMISS' &&
        event.detail.data &&
        event.detail.data.length
      ) {
        //do some processing on event.detail.data
      }
    }

    window.addEventListener('MOE_AUTOMATED_EVENTS', handler);

    return () => {
      window.removeEventListener('MOE_AUTOMATED_EVENTS', handler);
    };
  }, []);
}
